import { IFileResource, IResources } from '../../models/Resource';
import {
	IChatMediaMessage,
	IChatTextMessage,
	IChatVoiceMessage,
	MessageType,
	IMessageQuickRepliesMeta,
	IMessagePopupMeta,
	IChatMessages,
	SenderSource,
	IChatMessage,
} from '../../types';

export const isTextMessage = <T extends IChatMessages>(
	message?: T,
): message is T & IChatTextMessage => message?._type === MessageType.TEXT;

export const isQuickRepliesMessage = <T extends IChatMessages>(
	message?: T,
): message is T & IChatTextMessage<IMessageQuickRepliesMeta> =>
	isTextMessage(message) &&
	(!!message.metadata?.['gw.quick_replies']?.length ||
		!!message.metadata?.['telegram.reply_markup']?.keyboard.length ||
		!!message.metadata?.['gw.advanced_quick_replies']?.length);

export const isMediaMessage = <T extends IChatMessages>(
	message?: T,
): message is T & IChatMediaMessage => message?._type === MessageType.MEDIA;
export const isMediaMessageWithFile = <T extends IChatMessages>(
	message?: T,
): message is T & IChatMediaMessage<IFileResource> =>
	isMediaMessage(message) && !!message._data.data;

export const isVoiceMessage = <T extends IChatMessages>(
	message?: T,
): message is T & IChatVoiceMessage<IResources> =>
	message?._type === MessageType.VOICE;
export const isVoiceMessageWithFile = <T extends IChatMessages>(
	message?: T,
): message is T & IChatVoiceMessage<IFileResource> =>
	isVoiceMessage(message) && !!message._data.data;

export const isFileResourceMessage = <T extends IChatMessages>(
	message?: T,
): message is T &
	(IChatMediaMessage<IFileResource> | IChatVoiceMessage<IFileResource>) =>
	isMediaMessageWithFile(message) || isVoiceMessageWithFile(message);

export const isPopupMessage = <T extends IChatMessages>(
	message?: T,
): message is T & IChatTextMessage<IMessagePopupMeta> =>
	isTextMessage(message) && !!message.metadata?.['gw.popup'];

export const isInfoMessage = <T extends IChatMessage>(
	message?: T,
): message is T & IChatTextMessage<{}> & { sender: SenderSource.INFO } =>
	isTextMessage(message) && message.sender === SenderSource.INFO;
